import { render, staticRenderFns } from "./CategoryChart.vue?vue&type=template&id=2d1b09eb&scoped=true&"
import script from "./CategoryChart.vue?vue&type=script&lang=ts&"
export * from "./CategoryChart.vue?vue&type=script&lang=ts&"
import style0 from "./CategoryChart.vue?vue&type=style&index=0&id=2d1b09eb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d1b09eb",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/chuongdev/Desktop/project/209web_admin-chung-cu/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2d1b09eb')) {
      api.createRecord('2d1b09eb', component.options)
    } else {
      api.reload('2d1b09eb', component.options)
    }
    module.hot.accept("./CategoryChart.vue?vue&type=template&id=2d1b09eb&scoped=true&", function () {
      api.rerender('2d1b09eb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/dashboard/admin/components/chart/CategoryChart.vue"
export default component.exports